// import React, { useEffect, useState } from "react";
// import {
//   Stack,
//   Grid,
//   TextField,
//   Button,
//   Box,
//   IconButton,
//   FormControl,
//   InputLabel,
//   OutlinedInput,
//   InputAdornment,
//   Typography,
//   Paper,
// } from "@mui/material";
// import VisibilityIcon from "@mui/icons-material/Visibility";
// import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
// import HelpOutlineOutlinedIcon from "@mui/icons-material/HelpOutlineOutlined";
// import { useNavigate } from "react-router-dom";
// import { useDispatch } from "react-redux";
// import { fetchApidata, resetData } from "../../store/reducers/LoginReducer";
// import { toast } from "react-hot-toast";
// import { Formik } from "formik";
// import { LoadingButton } from "@mui/lab";
// import * as Yup from "yup";
// import "../../index.css";

// const Login = () => {
//   const navigate = useNavigate();
//   const dispatch = useDispatch();
//   const [loading, setLoading] = useState(false);
//   const [value, setValues] = useState({ showPassword: false });

//   useEffect(() => {
//     dispatch(resetData())
//   }, [])
//   const handleClickShowPassword = () => {
//     setValues((prev) => ({ ...prev, showPassword: !prev.showPassword }));
//   };

//   const validationSchema = Yup.object().shape({
//     usercode: Yup.string().required("Please enter the Usercode"),
//     password: Yup.string().required("Please enter the Password"),
//     license: Yup.string().required("Please enter the Subscription Code"),
//   });

//   const initialValues = {
//     usercode: "",
//     password: "",
//     license: "",
//   };

//   const fnLogin = async (values) => {
//     try {
//       setLoading(true);
//       const data = await dispatch(
//         fetchApidata(values.usercode.trim(), values.password, values.license.trim())
//       );

//       if (data.payload.Status === "Y") {
//         const { apiResponse, Recordid, EmpCount, ScrumMaster, CompanyAutoCode, Module, CompanyHeader, CompanyFooter, InvoiceFlag, CompanyLogo, ProjectManager, LoginType, MangerEmpID, FirstLevelSub, MangerEmpDetails } = data.payload;

//         sessionStorage.setItem("loginRecid", Recordid);
//         sessionStorage.setItem("UserName", apiResponse.Name);
//         sessionStorage.setItem("company", apiResponse.Company);
//         sessionStorage.setItem("companyId", apiResponse.EMP_CO);
//         sessionStorage.setItem("qualityassurance", apiResponse.EMP_QA);
//         // sessionStorage.setItem("companyLogo", CompanyLogo || "");
//         sessionStorage.setItem("year", apiResponse.Year);
//         sessionStorage.setItem("YearFlag", apiResponse.YearFlag);
//         sessionStorage.setItem("stockflag", apiResponse.Process);
//         sessionStorage.setItem("Cifbysea", apiResponse.Cifbysea);
//         sessionStorage.setItem("Cifbyair", apiResponse.Cifbyair);
//         sessionStorage.setItem("Fob", apiResponse.Fob);
//         sessionStorage.setItem("Overhead", apiResponse.Overhead);
//         sessionStorage.setItem("YearRecorid", apiResponse.EMP_FINYEAR);
//         sessionStorage.setItem("Groupaccess", JSON.stringify(apiResponse.Groupaccess));
//         sessionStorage.setItem("Modules", JSON.stringify(apiResponse.Modules));
//         sessionStorage.setItem("EmpId", apiResponse.EMP_RECID);
//         sessionStorage.setItem("EmpName", apiResponse.EMP_NAME);
//         sessionStorage.setItem("isManager", EmpCount);
//         sessionStorage.setItem("isScrumaster", ScrumMaster);
//         sessionStorage.setItem("CompanyAutoCode", CompanyAutoCode);
//         sessionStorage.setItem("Module", Module);
//         sessionStorage.setItem("CompanyLogo", CompanyLogo || "");
//         sessionStorage.setItem("InvoiceFlag", InvoiceFlag || "");
//         sessionStorage.setItem("CompanyHeader", CompanyHeader || "");
//         sessionStorage.setItem("CompanyFooter", CompanyFooter || "");
//         //       sessionStorage.setItem(

//         //   "CompanyLogo",
//         //   "https://bosuat.beyondexs.com/uploads/images/20251222_124012_logo_V1_1.png"
//         // );

//         sessionStorage.setItem("isprojectmanager", ProjectManager);
//         sessionStorage.setItem("MangerEmpID", JSON.stringify(MangerEmpID));
//         sessionStorage.setItem("FirstLevelSub", JSON.stringify(FirstLevelSub));
//         sessionStorage.setItem("MangerEmpDetails", JSON.stringify(MangerEmpDetails));
//         sessionStorage.setItem("currentPage", 0);
//         sessionStorage.setItem("secondaryCurrentPage", 0);
//         console.log(Module, "Modules");
//         setLoading(false);
//         if (LoginType === "1") {
//           navigate("/Changepassword");
//           return
//         }
//         if (EmpCount == 1 && ScrumMaster != "Y" && ProjectManager != "Y") {
//           navigate("/Apps/manager-dashbord/M");
//           return
//         }
//         if (apiResponse.EMP_QA == "Y" && EmpCount == 1) {
//           navigate("/Apps/scrum-dashbord/P");
//           return
//         }
//         if (ProjectManager == "Y" && EmpCount == 1) {
//           navigate("/Apps/scrum-dashbord/P");
//           return
//         }
//         if (ScrumMaster == "Y" && EmpCount == 1) {
//           navigate("/Apps/sprint-dashbord/S");
//           return
//         }
//         navigate("/Apps/dashbord/E");
//       }
//       //else {
//       //   setLoading(false);
//       //   toast.error(data.payload.Msg || "Enter a Valid Credential");
//       // }
//       else {
//         toast.error(
//           data?.payload?.Msg || "Invalid credentials"
//         );
//       }
//     } catch (err) {
//       toast.error("Unable to connect to server");
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <Box className="wrapper" sx={{ position: "relative", minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center" }}>
//       <IconButton sx={{ position: "absolute", top: 16, right: 16 }} color="info">
//         <HelpOutlineOutlinedIcon />
//       </IconButton>
//       <Paper elevation={6} sx={{ padding: 4, borderRadius: 3, maxWidth: 420, width: "100%" }}>
//         <Typography variant="h5" fontWeight="bold" textAlign="center" gutterBottom>
//           Welcome Back
//         </Typography>
//         <Typography variant="body2" textAlign="center" color="textSecondary" mb={2}>
//           Please login to your account
//         </Typography>
//         <Formik
//           initialValues={initialValues}
//           validationSchema={validationSchema}
//           onSubmit={(values, { setSubmitting }) => {
//             setTimeout(() => {
//               fnLogin(values);
//               setSubmitting(false);
//             }, 100);
//           }}
//         >
//           {({ values, errors, touched, handleChange, handleBlur, handleSubmit, resetForm }) => (
//             <form onSubmit={handleSubmit} noValidate>
//               <Stack spacing={2}>
//                 <TextField
//                   label="User Code"
//                   id="usercode"
//                   name="usercode"
//                   value={values.usercode}
//                   onChange={handleChange}
//                   onBlur={handleBlur}
//                   error={touched.usercode && Boolean(errors.usercode)}
//                   helperText={touched.usercode && errors.usercode}
//                   fullWidth
//                 />
//                 {/* <FormControl fullWidth variant="outlined">
//                   <InputLabel htmlFor="password">Password</InputLabel>
//                   <OutlinedInput
//                     id="password"
//                     name="password"
//                     type={value.showPassword ? "text" : "password"}
//                     value={values.password}
//                     onChange={handleChange}
//                     onBlur={handleBlur}
//                     error={touched.password && Boolean(errors.password)}
//                     endAdornment={
//                       <InputAdornment position="end">
//                         <IconButton onClick={handleClickShowPassword} edge="end">
//                           {value.showPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
//                         </IconButton>
//                       </InputAdornment>
//                     }
//                     label="Password"
//                   />
//                   {touched.password && errors.password && (
//                     <Typography variant="caption" color="error" ml={1.2}>
//                       {errors.password}
//                     </Typography>
//                   )}
//                 </FormControl> */}
//                 <FormControl
//                   fullWidth
//                   variant="outlined"
//                   error={touched.password && Boolean(errors.password)}
//                 >
//                   <InputLabel>Password</InputLabel>

//                   <OutlinedInput
//                     id="password"
//                     name="password"
//                     type={value.showPassword ? "text" : "password"}
//                     value={values.password}
//                     onChange={handleChange}
//                     onBlur={handleBlur}
//                     endAdornment={
//                       <InputAdornment position="end">
//                         <IconButton onClick={handleClickShowPassword} edge="end">
//                           {value.showPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
//                         </IconButton>
//                       </InputAdornment>
//                     }
//                     label="Password"
//                   />

//                   {touched.password && errors.password && (
//                     <Typography variant="caption" color="error" ml={1.4}>
//                       {errors.password}
//                     </Typography>
//                   )}
//                 </FormControl>

//                 <TextField
//                   label="Subscription Code"
//                   id="license"
//                   name="license"
//                   value={values.license}
//                   onChange={handleChange}
//                   onBlur={handleBlur}
//                   error={touched.license && Boolean(errors.license)}
//                   helperText={touched.license && errors.license}
//                   fullWidth
//                 />
//                 <Stack direction="row" justifyContent="space-between" alignItems="center">
//                   <Typography
//                     variant="body2"
//                     color="primary"
//                     sx={{ cursor: "pointer", textDecoration: "underline" }}
//                     onClick={() => navigate("/Forgotpassword")}
//                   >
//                     Forgot Password?
//                   </Typography>
//                   <Stack direction="row" spacing={1}>
//                     <LoadingButton
//                       type="submit"
//                       variant="contained"
//                       color="primary"
//                       loading={loading}
//                     >
//                       Login
//                     </LoadingButton>
//                     <Button
//                       variant="outlined"
//                       color="secondary"
//                       onClick={() => resetForm()}
//                     >
//                       Reset
//                     </Button>
//                   </Stack>
//                 </Stack>
//               </Stack>
//             </form>
//           )}
//         </Formik>
//       </Paper>
//     </Box>
//   );
// };

// export default Login;


// WORKING AS OF 13/02/2026
// import React, { useEffect, useState } from "react";
// import {
//   Stack,
//   Grid,
//   TextField,
//   Button,
//   Box,
//   IconButton,
//   FormControl,
//   InputLabel,
//   OutlinedInput,
//   InputAdornment,
//   Typography,
//   Paper,
// } from "@mui/material";
// import VisibilityIcon from "@mui/icons-material/Visibility";
// import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
// import HelpOutlineOutlinedIcon from "@mui/icons-material/HelpOutlineOutlined";
// import { useNavigate } from "react-router-dom";
// import { useDispatch } from "react-redux";
// import { fetchApidata, resetData } from "../../store/reducers/LoginReducer";
// import { toast } from "react-hot-toast";
// import { Formik } from "formik";
// import { LoadingButton } from "@mui/lab";
// import * as Yup from "yup";
// import "../../index.css";
// import background from "../../assets/img/BexATM.png";


// const Login = () => {
//   const navigate = useNavigate();
//   const dispatch = useDispatch();
//   const [loading, setLoading] = useState(false);
//   const [value, setValues] = useState({ showPassword: false });

//   useEffect(() => {
//     dispatch(resetData())
//   }, [])
//   const handleClickShowPassword = () => {
//     setValues((prev) => ({ ...prev, showPassword: !prev.showPassword }));
//   };

//   const validationSchema = Yup.object().shape({
//     usercode: Yup.string().required("Please enter the User Code"),
//     password: Yup.string().required("Please enter the Password"),
//     license: Yup.string().required("Please enter the Subscription Code"),
//   });

//   const initialValues = {
//     usercode: "",
//     password: "",
//     license: "",
//   };

//   const fnLogin = async (values) => {
//     try {
//       setLoading(true);
//       const data = await dispatch(
//         fetchApidata(values.usercode.trim(), values.password, values.license.trim())
//       );

//       if (data.payload.Status === "Y") {
//         const { apiResponse, Recordid, EmpCount, ScrumMaster, CompanyAutoCode, Module, CompanyHeader, CompanyFooter, InvoiceFlag, CompanyLogo, ProjectManager, LoginType, MangerEmpID, FirstLevelSub, MangerEmpDetails } = data.payload;

//         sessionStorage.setItem("loginRecid", Recordid);
//         sessionStorage.setItem("UserName", apiResponse.Name);
//         sessionStorage.setItem("company", apiResponse.Company);
//         sessionStorage.setItem("companyId", apiResponse.EMP_CO);
//         sessionStorage.setItem("qualityassurance", apiResponse.EMP_QA);
//         // sessionStorage.setItem("companyLogo", CompanyLogo || "");
//         sessionStorage.setItem("year", apiResponse.Year);
//         sessionStorage.setItem("YearFlag", apiResponse.YearFlag);
//         sessionStorage.setItem("stockflag", apiResponse.Process);
//         sessionStorage.setItem("Cifbysea", apiResponse.Cifbysea);
//         sessionStorage.setItem("Cifbyair", apiResponse.Cifbyair);
//         sessionStorage.setItem("Fob", apiResponse.Fob);
//         sessionStorage.setItem("Overhead", apiResponse.Overhead);
//         sessionStorage.setItem("YearRecorid", apiResponse.EMP_FINYEAR);
//         sessionStorage.setItem("Groupaccess", JSON.stringify(apiResponse.Groupaccess));
//         sessionStorage.setItem("Modules", JSON.stringify(apiResponse.Modules));
//         sessionStorage.setItem("EmpId", apiResponse.EMP_RECID);
//         sessionStorage.setItem("EmpName", apiResponse.EMP_NAME);
//         sessionStorage.setItem("isManager", EmpCount);
//         sessionStorage.setItem("isScrumaster", ScrumMaster);
//         sessionStorage.setItem("CompanyAutoCode", CompanyAutoCode);
//         sessionStorage.setItem("Module", Module);
//         sessionStorage.setItem("CompanyLogo", CompanyLogo || "");
//         sessionStorage.setItem("InvoiceFlag", InvoiceFlag || "");
//         sessionStorage.setItem("CompanyHeader", CompanyHeader || "");
//         sessionStorage.setItem("CompanyFooter", CompanyFooter || "");
//         //       sessionStorage.setItem(

//         //   "CompanyLogo",
//         //   "https://bosuat.beyondexs.com/uploads/images/20251222_124012_logo_V1_1.png"
//         // );

//         sessionStorage.setItem("isprojectmanager", ProjectManager);
//         sessionStorage.setItem("MangerEmpID", JSON.stringify(MangerEmpID));
//         sessionStorage.setItem("FirstLevelSub", JSON.stringify(FirstLevelSub));
//         sessionStorage.setItem("MangerEmpDetails", JSON.stringify(MangerEmpDetails));
//         sessionStorage.setItem("currentPage", 0);
//         sessionStorage.setItem("secondaryCurrentPage", 0);
//         console.log(Module, "Modules");
//         setLoading(false);
//         if (LoginType === "1") {
//           navigate("/Changepassword");
//           return
//         }
//         if (EmpCount == 1 && ScrumMaster != "Y" && ProjectManager != "Y") {
//           navigate("/Apps/manager-dashbord/M");
//           return
//         }
//         if (apiResponse.EMP_QA == "Y" && EmpCount == 1) {
//           navigate("/Apps/scrum-dashbord/P");
//           return
//         }
//         if (ProjectManager == "Y" && EmpCount == 1) {
//           navigate("/Apps/scrum-dashbord/P");
//           return
//         }
//         if (ScrumMaster == "Y" && EmpCount == 1) {
//           navigate("/Apps/sprint-dashbord/S");
//           return
//         }
//         navigate("/Apps/dashbord/E");
//       }
//       //else {
//       //   setLoading(false);
//       //   toast.error(data.payload.Msg || "Enter a Valid Credential");
//       // }
//       else {
//         toast.error(
//           data?.payload?.Msg || "Invalid credentials"
//         );
//       }
//     } catch (err) {
//       toast.error("Unable to connect to server");
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <Box className="wrapper">
//       <Box display={"table"} height="99vh" width="100%">
//         <IconButton sx={{ position: "absolute", top: 16, right: 16 }} color="info">
//           <HelpOutlineOutlinedIcon />
//         </IconButton>
//         <Grid
//           container
//           sx={{ display: "table-cell", verticalAlign: "middle" }}
//           rowSpacing={5}
//           columnSpacing={{ xs: 1, sm: 2, md: 3 }}
//         >
//           <Formik
//             initialValues={initialValues}
//             validationSchema={validationSchema}
//             onSubmit={(values, { setSubmitting }) => {
//               setTimeout(() => {
//                 fnLogin(values);
//                 setSubmitting(false);
//               }, 100);
//             }}
//           >
//             {({ values, errors, touched, handleChange, handleBlur, handleSubmit, resetForm }) => (
//               <form onSubmit={handleSubmit} noValidate>
//                 <Stack

//                   height={{ sm: "450px", md: "100%" }}
//                   width={{ sm: "291px", md: "700px" }}
//                   sx={{
//                     boxShadow: "rgba(0, 0, 0, 0.35) 0px 5px 15px",
//                     borderRadius: "10px",
//                     backgroundColor: "white",
//                     padding: "15px",
//                     margin: "20px auto",
//                   }}
//                   spacing={{ sm: 4, md: 2 }}
//                   autoComplete="off"
//                   direction={{ sm: "column", md: "row" }}
//                 >
//                   <Stack
//                     sx={{
//                       width: { sm: "100%", md: "100%", lg: "100%" },
//                       height: "100%",
//                       display: "flex",
//                       flexDirection: "column",
//                       alignContent: "center",
//                       justifyContent: "flexend",
//                       alignItems: "center",
//                       backgroundImage: `url(${background})`,
//                       backgroundRepeat: "no-repeat",
//                       backgroundPosition: "center",
//                       backgroundSize: "75%",
//                       padding: 1,
//                       borderRadius: "5px",
//                       height:  "325px",
//                       // height: { sm: "300px", md: "325px" },
//                       // marginBottom: "50px",
//                       marginTop: "-30px",
//                       flexDirection: "column-reverse",
//                     }}
//                     spacing={2}

//                   >
//                     <Typography
//                       variant="p"
//                       sx={{

//                         marginBottom: { sm: 3, md: 7 },
//                         // marginRight: 2,
//                         textAlign: "center",
//                         // fontWeight: "600",
//                         fontSize:"13px",
//                       }}
//                     >

//                       Version 1.0
//                     </Typography>
//                     <Typography
//                       variant="h6"
//                       sx={{
//                         fontWeight: "600",
//                         marginTop: 2,
//                         // marginRight: 2,
//                         textAlign: "center",
//                       }}
//                     >
//                       Employee Self Service
//                     </Typography>
//                   </Stack>

//                   <Stack spacing={2.5}
//                     sx={{
//                       width: { sm: "100%", md: "100%", lg: "100%" },
//                     }}>
//                     <TextField
//                       label="User Code"
//                       id="usercode"
//                       name="usercode"
//                       value={values.usercode}
//                       onChange={handleChange}
//                       onBlur={handleBlur}
//                       error={touched.usercode && Boolean(errors.usercode)}
//                       helperText={touched.usercode && errors.usercode}
//                       fullWidth
//                       sx={{
//                         marginTop: "30px"
//                       }}
//                       focused
//                     />
//                     <FormControl
//                     focused
//                       fullWidth
//                       variant="outlined"
//                       error={touched.password && Boolean(errors.password)}
//                     >
//                       <InputLabel>Password</InputLabel>

//                       <OutlinedInput
//                         id="password"
//                         name="password"
//                         type={value.showPassword ? "text" : "password"}
//                         value={values.password}
//                         onChange={handleChange}
//                         onBlur={handleBlur}
//                         endAdornment={
//                           <InputAdornment position="end">
//                             <IconButton onClick={handleClickShowPassword} edge="end">
//                               {value.showPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
//                             </IconButton>
//                           </InputAdornment>
//                         }
//                         label="Password"
//                         focused
//                       />

//                       {touched.password && errors.password && (
//                         <Typography variant="caption" color="error" ml={1.4}>
//                           {errors.password}
//                         </Typography>
//                       )}
//                     </FormControl>

//                     <TextField
//                       label="Subscription Code"
//                       id="license"
//                       name="license"
//                       value={values.license}
//                       onChange={handleChange}
//                       onBlur={handleBlur}
//                       error={touched.license && Boolean(errors.license)}
//                       helperText={touched.license && errors.license}
//                       fullWidth
//                       focused
//                     />
//                     <Stack direction="row" justifyContent="space-between" alignItems="center">
//                       <Typography
//                         variant="body2"
//                         color="primary"
//                         sx={{ cursor: "pointer", textDecoration: "underline" }}
//                         onClick={() => navigate("/Forgotpassword")}
//                       >
//                         Forgot Password?
//                       </Typography>
//                       <Stack direction="row" spacing={1}>
//                         <LoadingButton
//                           type="submit"
//                           variant="contained"
//                           color="primary"
//                           loading={loading}
//                         >
//                           Login
//                         </LoadingButton>
//                         <Button
//                           variant="outlined"
//                           color="secondary"
//                           onClick={() => resetForm()}
//                         >
//                           Reset
//                         </Button>
//                       </Stack>
//                     </Stack>
//                   </Stack>
//                 </Stack>
//               </form>
//             )}
//           </Formik>
//         </Grid>
//       </Box>
//     </Box>
//   );
// };

// export default Login;
import {
  Stack,
  Grid,
  TextField,
  Button,
  Box,
  IconButton,
  FormControl,
  InputLabel,
  OutlinedInput,
  InputAdornment,
  Typography,
  Paper,
  Card,
  FormControlLabel,
  Checkbox,
  Link,
} from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import HelpOutlineOutlinedIcon from "@mui/icons-material/HelpOutlineOutlined";
import { useNavigate } from "react-router-dom";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { fetchApidata, resetData } from "../../store/reducers/LoginReducer";
import { toast } from "react-hot-toast";
import { Formik } from "formik";
import { LoadingButton } from "@mui/lab";
import * as Yup from "yup";
import "../../index.css";
// import background from "../../assets/img/ESS_final.png";
// import background from "../../assets/img/ESS_CoverImg1.png";
import background from "../../assets/img/Ess_CoverImage.png";
import { styled } from "@mui/system";

const FlexBox = styled(Box)(() => ({
  display: "flex",
  alignItems: "center",
}));

const JustifyBox = styled(FlexBox)(() => ({
  justifyContent: "center",
}));

const ContentBox = styled(Box)(({ theme }) => ({
  height: "100%",
  padding: theme.spacing(4),
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  [theme.breakpoints.down("sm")]: {
    minHeight: "100vh",
    justifyContent: "center",
  },
}));

const JWTRoot = styled(JustifyBox)(({ theme }) => ({
  minHeight: "90vh",
  "& .card": {
    width: "100%",
    minHeight: "90vh",
    display: "flex",
    // borderRadius: 12,
    overflow: "hidden",
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      boxShadow: "none",
      borderRadius: 0,
      minHeight: "90vh",
    },
  },
}));

const StyledTextField = styled(TextField)(({ theme }) => ({
  "& .MuiOutlinedInput-root": {
    backgroundColor: "#f5f9fa",
    borderRadius: "8px",
    "& fieldset": {
      borderColor: "#e0e0e0",
    },
    "&:hover fieldset": {
      borderColor: "#00796b",
    },
    "&.Mui-focused fieldset": {
      borderColor: "#00796b",
    },
  },
  "& .MuiInputLabel-root": {
    color: "#666",
  },
  "& .MuiInputLabel-root.Mui-focused": {
    color: "#00796b",
  },
}));

const StyledOutlinedInput = styled(OutlinedInput)(({ theme }) => ({
  backgroundColor: "#f5f9fa",
  borderRadius: "8px",
  "& fieldset": {
    borderColor: "#e0e0e0",
  },
  "&:hover fieldset": {
    borderColor: "#00796b",
  },
  "&.Mui-focused fieldset": {
    borderColor: "#00796b",
  },
}));


const LoginButton = styled(LoadingButton)(({ theme }) => ({
  // backgroundColor: "#00796b",
  background: "#0A4063",
  background: "radial-gradient(circle, rgba(10, 64, 99, 1) 40%, rgba(6, 128, 150, 1) 100%)",
  color: "#ffffff",
  padding: "12px 0",
  borderRadius: "8px",
  fontSize: "16px",
  fontWeight: 600,
  textTransform: "none",
  // "&:hover": {
  //   backgroundColor: "#00695c",
  // },
  "&:hover": {
    background: "radial-gradient(circle, rgba(10, 64, 99, 1) 40%, rgba(6, 128, 150, 1) 100%)",
  },

  "& .MuiCircularProgress-root": {
    color: "#ffffff",
  },
}));

const Login = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  // const [value, setValues] = useState({ showPassword: false });
  const formikRef = useRef();

  // useEffect(() => {
  //   dispatch(resetData())
  // }, [])
  const [initialValues, setInitialValues] = useState({
    usercode: "",
    password: "",
    license: "",
    remember: false,
  });
  useEffect(() => {
    const rememberedData = localStorage.getItem("rememberMeData");

    if (rememberedData) {
      const parsedData = JSON.parse(rememberedData);

      setInitialValues({
        usercode: parsedData.usercode || "",
        password: parsedData.password || "",
        license: parsedData.license || "",
        remember: true,
      });
    }
  }, []);
  // const handleClickShowPassword = () => {
  //   setValues((prev) => ({ ...prev, showPassword: !prev.showPassword }));
  // };
  const [showPassword, setShowPassword] = useState(false);

  const handleClickShowPassword = () => {
    setShowPassword((prev) => !prev);
  };
  const validationSchema = Yup.object().shape({
    usercode: Yup.string().required("Please enter the User Code"),
    password: Yup.string().required("Please enter the Password"),
    license: Yup.string().required("Please enter the Subscription Code"),
  });

  // const initialValues = {
  //   usercode: "",
  //   password: "",
  //   license: "",
  //   remember: false,
  // };

  const fnLogin = async (values) => {
    try {
      setLoading(true);
      const data = await dispatch(
        fetchApidata(values.usercode.trim(), values.password, values.license.trim())
      );

      if (data.payload.Status === "Y") {
 
        
        const { apiResponse, Recordid, EmpCount, ScrumMaster, CompanyAutoCode, Module, CompanyHeader, CompanyFooter, InvoiceFlag, CompanyGraceTime, CompanySessionTimeOut, CompanyLogo, ProjectManager, MultipleChildren, EmpMailID, EmpMobileNo, ParentID, LoginType, MangerEmpID,ClassificationData, FirstLevelSub, MangerEmpDetails, SubscriptionCode,CompanySignature,Classification, CompanyQRCode} = data.payload;
        if (values.remember) {
          localStorage.setItem("rememberMeData", JSON.stringify({
            usercode: values.usercode,
            password: values.password,
            license: values.license,
            remember: true,
          }));
          console.log("Saved:", localStorage.getItem("rememberMeData"));
        } else {
          localStorage.removeItem("rememberMeData");
        }
         console.log("Classification:",Classification);
        sessionStorage.setItem("loginRecid", Recordid);
        sessionStorage.setItem("UserName", apiResponse.Name);
        sessionStorage.setItem("company", apiResponse.Company);
        sessionStorage.setItem("companyId", apiResponse.EMP_CO);
        sessionStorage.setItem("qualityassurance", apiResponse.EMP_QA);
        sessionStorage.setItem("SubscriptionCode", SubscriptionCode);
        sessionStorage.setItem("year", apiResponse.Year);
        sessionStorage.setItem("YearFlag", apiResponse.YearFlag);
        sessionStorage.setItem("stockflag", apiResponse.Process);
        sessionStorage.setItem("Cifbysea", apiResponse.Cifbysea);
        sessionStorage.setItem("Cifbyair", apiResponse.Cifbyair);
        sessionStorage.setItem("Fob", apiResponse.Fob);
        sessionStorage.setItem("Overhead", apiResponse.Overhead);
        sessionStorage.setItem("YearRecorid", apiResponse.EMP_FINYEAR);
        sessionStorage.setItem("Groupaccess", JSON.stringify(apiResponse.Groupaccess));
        sessionStorage.setItem("Modules", JSON.stringify(apiResponse.Modules));
        sessionStorage.setItem("EmpId", apiResponse.EMP_RECID);
        sessionStorage.setItem("Locname", apiResponse.L_NAME);
        sessionStorage.setItem("Locid", apiResponse.EMP_LRECID);
        sessionStorage.setItem("Gateid", apiResponse.EMP_SGMRECID);
        sessionStorage.setItem("Gatename", apiResponse.SGM_NAME);
        sessionStorage.setItem("EmpName", apiResponse.EMP_NAME);
        sessionStorage.setItem("isManager", EmpCount);
        sessionStorage.setItem("isScrumaster", ScrumMaster);
        sessionStorage.setItem("Classification", Classification);
        sessionStorage.setItem("ClassificationRecID", apiResponse.EMP_CFCRECID);
        sessionStorage.setItem("CompanyAutoCode", CompanyAutoCode);
        sessionStorage.setItem("Module", Module);
        sessionStorage.setItem("CompanyLogo", CompanyLogo || "");
        sessionStorage.setItem("InvoiceFlag", InvoiceFlag || "");
        sessionStorage.setItem("CompanyHeader", CompanyHeader || "");
        sessionStorage.setItem("CompanyQRCode", CompanyQRCode || "");
        sessionStorage.setItem("CompanyFooter", CompanyFooter || "");
        sessionStorage.setItem("CompanySignature", CompanySignature || "");
        sessionStorage.setItem("CompanyGraceTime", CompanyGraceTime || "");
        sessionStorage.setItem("CompanySessionTimeOut", CompanySessionTimeOut || "");

        //       sessionStorage.setItem(

        //   "CompanyLogo",
        //   "https://bosuat.beyondexs.com/uploads/images/20251222_124012_logo_V1_1.png"
        // );

        sessionStorage.setItem("isprojectmanager", ProjectManager);
        sessionStorage.setItem("MultipleChildren", MultipleChildren);

        sessionStorage.setItem("EmpMailID",EmpMailID);
        sessionStorage.setItem("EmpMobileNo", EmpMobileNo);
        sessionStorage.setItem("ParentID", ParentID);
        sessionStorage.setItem("MangerEmpID", JSON.stringify(MangerEmpID));
        sessionStorage.setItem("ManagerEmpIDCS", MangerEmpID.join(","));
        sessionStorage.setItem("EMP_TRAINBY", apiResponse.EMP_TRAINBY);
        sessionStorage.setItem("FirstLevelSub", JSON.stringify(FirstLevelSub));
        sessionStorage.setItem("MangerEmpDetails", JSON.stringify(MangerEmpDetails));
        sessionStorage.setItem("ClassificationData", JSON.stringify(ClassificationData));
        sessionStorage.setItem("currentPage", 0);
        sessionStorage.setItem("secondaryCurrentPage", 0);
        console.log(Module,MultipleChildren,ParentID,  "Modules");
        setLoading(false);
        if (LoginType === "1") {
          navigate("/Changepassword");
          return
        }
       
        if (apiResponse.EMP_QA == "Y" && EmpCount == 1) {
          // navigate("/Apps/scrum-dashbord/P");
          navigate("/Apps/scrum-dashbord/PM");
          return
        }
         if (EmpCount == 1 && ScrumMaster != "Y" && ProjectManager != "Y") {
          navigate("/Apps/manager-dashbord/M");
          return
        }
        if (ProjectManager == "Y" && EmpCount == 1) {
          // navigate("/Apps/scrum-dashbord/P");
          navigate("/Apps/scrum-dashbord/PM");
          return
        }
        if (ScrumMaster == "Y" && EmpCount == 1) {
          navigate("/Apps/sprint-dashbord/S");
          // navigate("/Apps/scrum-master-dashbord/S");
          return
        }

        navigate("/Apps/dashbord/E");

      }
      //else {
      //   setLoading(false);
      //   toast.error(data.payload.Msg || "Enter a Valid Credential");
      // }
      else {
        toast.error(
          data?.payload?.Msg || "Invalid credentials"
        );
      }
    } catch (err) {
      toast.error("Unable to connect to server");
    } finally {
      setLoading(false);
    }
  };

  return (
    <JWTRoot>
      <Card
        className="card"
        sx={{
          width: "100%",
          boxShadow: { xs: "none", sm: 3 },
          borderRadius: { xs: 0, sm: 0 },

          // ✅ Add this
          backgroundImage: {
            xs: `url(${background})`,
            sm: "none",
          },
          backgroundSize: {
            xs: "cover",
            sm: "unset",
          },
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
        }}
      >
        <Grid container sx={{ height: "100vh" }}>
          {/* Left Side: Login Form */}
          <Grid item sm={7} xs={12}>
            <ContentBox
              sx={{
                mx: "auto",
                width: "100%",
                maxWidth: { xs: "95%", sm: 420 },
                // px: { xs: 2, sm: 6 },
                paddingRight: { xs: 2, sm: 6 },
                paddingLeft: { xs: 1, sm: 6 },
                paddingTop: { xs: 0, sm: 0 },
                paddingBottom: { xs: 0, sm: 0 },
                backgroundColor: "#ffffff",
                // ✅ Transparent on xs so background shows
                backgroundColor: {
                  xs: "rgba(255,255,255,0.85)",
                  sm: "#ffffff",
                },
                backdropFilter: {
                  xs: "blur(15px)",
                  sm: "none",
                },

              }}
            >
              {/* Header */}
              <Box mb={3}>
                <Typography
                  variant="h6"
                  sx={{
                    fontSize: { xs: "20px", sm: "30px" },
                    fontWeight: 600,
                    mb: 0,

                    // background: "linear-gradient(180deg, rgba(10,64,99,1) 53%, rgba(6,128,150,1) 100%)",
                    background: "linear-gradient(180deg,rgba(10, 64, 99, 1) 37%, rgba(6, 128, 150, 1) 100%)",
                    WebkitBackgroundClip: "text",
                    WebkitTextFillColor: "transparent",
                    backgroundClip: "text",
                    color: "transparent",
                    textAlign: "center"
                  }}
                >
                  Login to your Account
                </Typography>
              </Box>

              {/* Form */}
              <Formik
                innerRef={formikRef}
                initialValues={initialValues}
                enableReinitialize
                validationSchema={validationSchema}
                onSubmit={(values, { setSubmitting }) => {
                  setTimeout(() => {
                    fnLogin(values);
                    setSubmitting(false);
                  }, 100);
                }}
              >
                {({ values, errors, touched, handleChange, handleBlur, handleSubmit, resetForm }) => (
                  <form onSubmit={handleSubmit} noValidate>




                    <Stack spacing={2}
                      sx={{
                        width: { sm: "100%", md: "100%", lg: "100%" },
                      }}>
                      <StyledTextField
                        name="usercode"
                        label="User Code"
                        id="usercode"
                        placeholder="User Code"
                        value={values.usercode}
                        onBlur={handleBlur}
                        onChange={handleChange}
                        fullWidth
                        error={!!touched.usercode && !!errors.usercode}
                        helperText={touched.usercode && errors.usercode}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <Box sx={{ color: "#999", fontSize: "20px" }}>#</Box>
                            </InputAdornment>
                          ),
                        }}
                      />
                      {/* <FormControl
                        focused
                        fullWidth
                        variant="outlined"
                        error={touched.password && Boolean(errors.password)}
                      >
                        <InputLabel
                          sx={{
                            color: "#666",
                            "&.Mui-focused": { color: "#00796b" },
                          }}
                        >Password</InputLabel>

                        <StyledOutlinedInput
                          id="password"
                          name="password"
                          type={showPassword ? "text" : "password"}
                          value={values.password}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          // endAdornment={
                          //   <InputAdornment position="end">
                          //     <IconButton onClick={handleClickShowPassword} edge="end">
                          //       {value.showPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
                          //     </IconButton>
                          //   </InputAdornment>
                          // }
                          startAdornment={
                            <InputAdornment position="start">
                              <Box sx={{ color: "#999", fontSize: "18px" }}>🔒</Box>
                            </InputAdornment>
                          }
                          endAdornment={
                            <InputAdornment position="end">
                              <IconButton
                                onClick={handleClickShowPassword}
                                edge="end"
                                sx={{ color: "#999" }}
                              >
                                {showPassword ? (
                                  <VisibilityOffIcon />
                                ) : (
                                  <VisibilityIcon />
                                )}
                              </IconButton>
                            </InputAdornment>
                          }
                          label="Password"
                          focused
                        />

                        {touched.password && errors.password && (
                          <Typography variant="caption" color="error" ml={1.4}>
                            {errors.password}
                          </Typography>
                        )}
                      </FormControl> */}
                      <StyledTextField
                        name="password"
                        label="Password"
                        type={showPassword ? "text" : "password"}
                        value={values.password}
                        onBlur={handleBlur}
                        onChange={handleChange}
                        placeholder="Password"
                        fullWidth
                        error={!!touched.password && !!errors.password}
                        helperText={touched.password && errors.password}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <Box sx={{ color: "#999", fontSize: "17px" }}>🔒</Box>
                            </InputAdornment>
                          ),
                          endAdornment: (
                            <InputAdornment position="end">
                              <IconButton onClick={handleClickShowPassword} edge="end">
                                {showPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
                              </IconButton>
                            </InputAdornment>
                          ),
                          sx: {
                            paddingRight: "14px",
                            paddingLeft: "7px",
                          },
                        }}
                      // focused
                      />

                      <StyledTextField
                        label="Subscription Code"
                        id="license"
                        name="license"
                        placeholder="Subscription Code"
                        value={values.license}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={touched.license && Boolean(errors.license)}
                        helperText={touched.license && errors.license}
                        fullWidth
                        focused
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <Box sx={{ color: "#999", fontSize: "20px" }}>#</Box>
                            </InputAdornment>
                          ),
                        }}
                      />
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          // mt: 0.5,
                        }}
                      >

                        <FormControlLabel
                          control={
                            <Checkbox
                              name="remember"
                              checked={values.remember}
                              onChange={handleChange}
                              sx={{
                                color: "#00796b",
                                "&.Mui-checked": {
                                  color: "#00796b",
                                },
                              }}
                            />
                          }
                          label={
                            <Typography sx={{ color: "#666", fontSize: "14px" }}>
                              Remember me
                            </Typography>
                          }
                        />
                        <Link
                          onClick={() => navigate("/Forgotpassword")}
                          sx={{
                            // color: "#00796b",
                            color: "#608dcb",
                            fontSize: "14px",
                            cursor: "pointer",
                            textDecoration: "none",
                            "&:hover": {
                              textDecoration: "underline",
                            },
                          }}
                        >
                          Forget Password?
                        </Link>


                        {/* <Button
                            variant="outlined"
                            color="secondary"
                            onClick={() => resetForm()}
                          >
                            Reset
                          </Button> */}

                      </Box>
                      <LoginButton
                        type="submit"
                        loading={loading}
                        variant="contained"
                        fullWidth
                      // sx={{ mt: 2 }}
                      >
                        Login
                      </LoginButton>
                    </Stack>

                  </form>
                )}
              </Formik>
            </ContentBox>
          </Grid>
          {/* Right Side: Image */}
          <Grid
            item
            sm={5}
            xs={false}
            sx={{
              display: { xs: "none", sm: "flex" },
              alignItems: "center", // CHANGED: Added to center vertically
              justifyContent: "center",
            }}
          >
            <Box
              sx={{
                backgroundImage: `url(${background})`,
                // backgroundSize: "cover",
                backgroundSize: "contain",
                backgroundSize: "100% 100%",
                backgroundRepeat: "no-repeat",
                backgroundPosition: "center center",
                // height: "100%",
                height: "98vh",
                minHeight: "100vh",
                width: "100%",
              }}

            />
          </Grid>

        </Grid>
      </Card>
    </JWTRoot >
  );
};

export default Login;